import React from 'react';
import { Link } from 'react-router-dom';
import CTAConsultation from './CTAConsultation'; // Adjust path as needed

const NextSteps = () => {
  return (
    <section className="bg-gradient-to-b from-gray-50 to-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <h3 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#0e6d87] mb-4 sm:mb-6 tracking-tight">
          Launch Your Career Transformation
        </h3>
        <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 max-w-2xl mx-auto leading-relaxed">
          Ready to land your dream job or take your career to the next level? Navam’s expert guidance and tailored strategies will empower you to achieve your professional goals. Start your journey today.
        </p>
        <div className="border-t border-gray-200 w-24 mx-auto mb-6 sm:mb-8"></div>
        <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6">
          <CTAConsultation ctaType="general" />
          <Link
            to="/services"
            className="inline-block bg-gray-200 text-gray-800 px-6 py-3 rounded-full text-base sm:text-lg font-medium hover:bg-gray-300 hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1"
          >
            Explore Our Career Services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NextSteps;